export interface ActionHandler<TState, TAction> {
    action: TAction
    handler: (state: TState, params: any) => TState
}

export function createReducer<TState, TAction>(initialState: TState, actionHandlers: ActionHandler<TState, TAction>[]) {
    const actionHandlerMap: { [action: string]: (state: TState, params: any) => TState } = {}
    actionHandlers.forEach(it => actionHandlerMap[(<any>it.action)] = it.handler)
    return function(state = initialState, action: { type: TAction, params: any }) {
        if (!(<any>action.type in actionHandlerMap)) {
            console.warn(`Missing action handler for ${action.type}.`)
            return state
        }
        return actionHandlerMap[<any>action.type].call(this, state, action.params)
    }
}